import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {
  _coupon: {
    items: [],
    totalPage: 0,
    totalCount: 0,
  },
  _user: {
    items: [],
    totalPage: 0,
    totalCount: 0,
  },
  _detail: {},
};

export const mutations = {
  setCoupon(state, coupons) {
    state._coupon.items = coupons.items;
    state._coupon.totalPage = coupons.totalPage;
    state._coupon.totalCount = coupons.totalCount;
  },
  setUser(state, users) {
    state._user.items = users.items;
    state._user.totalPage = users.totalPage;
    state._user.totalCount = users.totalCount;
  },
  setDetail(state, detail) {
    state._detail = detail;
  },
};

export const actions = {
  async acOrderCouponList({ commit }, { page, pageSize, applyType, couponType }) {
    const url = `/api/v1/order-coupon`;
    try {
      const result = await api.get(url, { params: { page, pageSize, applyType, couponType } });
      commit("setCoupon", result.data?.data);
      return result.data?.code === 0;
    } catch (err) {
      return false;
    }
  },
  async acOrderCouponUserList({ commit }, { code, page, pageSize }) {
    const url = `/api/v1/order-coupon/users`;
    try {
      const result = await api.get(url, { params: { code, page, pageSize } });
      commit("setUser", result.data?.data);
      return result.data?.code === 0;
    } catch (err) {
      return false;
    }
  },
  async acOrderCounponAdd({ commit }, payload) {
    const url = `/api/v1/order-coupon`;
    try {
      const result = await api.post(url, payload);
      return result.data?.code === 0;
    } catch (err) {
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
